import { Dispatch, SetStateAction, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Button } from '../../../components/common/Button/Button';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { lightTheme } from '../../../styles/GlobalStyles';
import { Icon, IconWithdrawNFT } from '../../../styles/Icons';
import { WithdrawStepsEnum } from './types';
import { P1, P2 } from '../../../styles/FontStyles';
import { CheckText } from '../../../components/common/CheckText';

import { settingsInit } from '../../Settings/Settings.actions';

interface Step1Props {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
}

export const Step1 = ({ setWithdrawStep, setOpenModal }: Step1Props) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='12'>
              <IconWithdrawNFT />
            </Icon>
          </Flexed>
        </Flexed>
        <P1 bold center mb='20' color={lightTheme.colors.neutral500}>
          WHAT DOES WITHDRAWING YOUR HUB NFT MEAN?
        </P1>
        <P2 bold center mb='20'>
          YOU ARE TRYING TO WITHDRAW YOUR HUB NFT TO YOUR CRYPTO WALLET. BEFORE
          YOU DECIDE TO MAKE THIS ACTION, PLEASE READ EVERYTHING STATED BELOW
          CAREFULLY TO AVOID LOSING YOUR HUB NFT.
          <br />
          <br />
          THIS ACTION IS IRREVERSIBLE. WITHDRAWING YOUR NFT TO A WRONG WALLET
          MEANS THAT YOU WILL FOREVER LOSE ACCESS TO YOUR NFT.
        </P2>
        <P1 bold center mb='20' color={lightTheme.colors.primary900}>
          BY WITHDRAWING YOUR HUB NFT:
        </P1>
        <CheckText
          x
          checkColor={lightTheme.colors.error500}
          text={
            'Your NFT can forever be lost, if you lose the keys to your wallet, transfer to a wrong wallet, get hacked or any other reason connected to handling your own crypto wallet.'
          }
        />
        <CheckText
          x
          checkColor={lightTheme.colors.error500}
          text={'Your NFT will no longer count towards Binary Weekly Cap.'}
        />
        <CheckText
          checkColor={lightTheme.colors.success500}
          text={
            'You will keep Personal Orders (PO) qualifications for ranks in the MaVie compensation plan.'
          }
        />
        <CheckText
          checkColor={lightTheme.colors.success500}
          text={
            'You will keep receiving all your rewards from your Hub NFT directly to the wallet where you hold your Hub NFT.'
          }
        />
      </Box>

      <Flexed>
        <Button mt='20' mr='10' negative onClick={() => setOpenModal(false)}>
          Back to My Hubs
        </Button>
        <Button
          mt='20'
          ml='10'
          onClick={() => {
            dispatch(settingsInit());
            setWithdrawStep(WithdrawStepsEnum.APPROVE_TRANSACTION);
          }}>
          Continue
        </Button>
      </Flexed>
    </>
  );
};
